import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { createTheme, CssBaseline } from "@mui/material";
import SideBar from "./components/SideBar";
import { Box } from "@mui/system";
import { ThemeProvider } from "@emotion/react";
import DashBoardScreen from "./screens/DashBoardScreen";
import { darkTheme, lightTheme } from "./config/theme";
import LoginScreen from "./screens/LoginScreen";
import SignUp from "./screens/SignUp";
import PageLayout from "./components/layout/PageLayout";
import AddBrand from "./screens/brands/AddBrand";
import BrandList from "./screens/brands/BrandList";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BrandEdit from "./screens/brands/BrandEdit";
import AddCategories from "./screens/categories/AddCategories";
import CategoryList from "./screens/categories/CategoryList";
import EditCategory from "./screens/categories/EditCategory";
import ListAttributes from "./screens/attributes/ListAttributes";
import EditAttribute from "./screens/attributes/EditAttribute";
import CreateAttribute from "./screens/attributes/CreateAttribute";
import ListStores from "./screens/stores/ListStores";
import EditStore from "./screens/stores/EditStore";
import CreateStore from "./screens/stores/CreateStore";
import ListProduct from "./screens/products/ListProduct";
import EditProduct from "./screens/products/EditProduct";
import AddProduct from "./screens/products/AddProduct";
import AddOrder from "./screens/orders/AddOrder";
import ListOrder from "./screens/orders/ListOrder";
import EditOrder from "./screens/orders/EditOrder";
import NotFound from "./screens/NotFound";
import Invoice from "./components/Invoice";
import { useSelector } from "react-redux";

const App = () => {
  const themeChange = useSelector((state) => state.themeChange);
  const { theme } = themeChange;

  console.log(theme);

  return (
    <ThemeProvider theme={theme === "light" ? lightTheme : darkTheme}>
      <CssBaseline />
      <ToastContainer />

      <Router>
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/signup" element={<SignUp />} />
        </Routes>
        <PageLayout>
          <Routes>
            <Route path="/addbrand" element={<AddBrand />} />
            <Route path="/addcategory" element={<AddCategories />} />
            <Route path="/category" element={<CategoryList />} />
            <Route path="/category/:id" element={<EditCategory />} />
            <Route path="/brands" element={<BrandList />} />
            <Route path="/brand/:id" element={<BrandEdit />} />
            <Route path="/attribute" element={<ListAttributes />} />
            <Route path="/attribute/:id" element={<EditAttribute />} />
            <Route path="/createAttribute" element={<CreateAttribute />} />
            <Route path="/store" element={<ListStores />} />
            <Route path="/store/:id" element={<EditStore />} />
            <Route path="/addStore" element={<CreateStore />} />
            <Route path="/products" element={<ListProduct />} />
            <Route path="/product/:id" element={<EditProduct />} />
            <Route path="/addProduct" element={<AddProduct />} />
            <Route path="/addOrder" element={<AddOrder />} />
            <Route path="/orders" element={<ListOrder />} />
            <Route path="/order/:id" element={<EditOrder />} />
            <Route path="/order/invoice/:id" element={<Invoice />} />
            <Route path="/dashboard" element={<DashBoardScreen />} />
          </Routes>
        </PageLayout>
      </Router>
    </ThemeProvider>
  );
};

export default App;
